import { isBoolean, isEmpty } from 'lodash-es'

const onYesNoFilter = property => (filterValue, item) => {
  if (!isBoolean(filterValue)) return true
  const isPropertyEmpty = isEmpty(item[property])
  return filterValue ? !isPropertyEmpty : isPropertyEmpty
}

export default onYesNoFilter
